module.exports = __webpack_public_path__ + "img/user.43b9bf5b.svg";